import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'secondary'

interface ButtonLinkProps {
    href: string
    children: ReactNode
    variant?: ButtonVariant
    className?: string
    onClick?: () => void
}

export const buttonClasses = (variant: ButtonVariant = 'primary'): string => cn(
    'group inline-flex h-12 items-center justify-center gap-2 rounded-full px-6 text-[15px] font-medium tracking-[-0.01em] transition-colors duration-300',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-azure-500',
    variant === 'primary'
        ? 'bg-ink text-white hover:bg-azure-600'
        : 'border border-ink/15 bg-white/80 text-ink backdrop-blur-sm hover:border-ink'
)

export const ButtonLink: FC<ButtonLinkProps> = ({
    href,
    children,
    variant = 'primary',
    className,
    onClick
}): ReactNode => {
    return (
        <a href={href} onClick={onClick} className={cn(buttonClasses(variant), className)}>
            {children}
        </a>
    )
}
